import { Controller } from "@hotwired/stimulus"

const FIELD = "[data-field-error]"
const ERROR = '[role="alert"]'

export default class extends Controller {
  connect() {
    const firstError = Array.from(this.element.querySelectorAll(ERROR)).find(
      (element) => element.textContent.trim() !== "",
    )
    if (!firstError) return

    firstError.closest(FIELD)?.scrollIntoView({ block: "center" })
  }

  clear(event) {
    const field = event.target.closest?.(FIELD)
    if (!field || !this.element.contains(field)) return

    field.querySelectorAll('[aria-invalid="true"]').forEach((element) => {
      element.removeAttribute("aria-invalid")
    })
    field.querySelectorAll(ERROR).forEach((element) => {
      if (element.hasAttribute("data-contacts--picture-upload-target")) return
      element.remove()
    })
  }
}
